const mutation = {
  SET_SETTINGS_LOADING(state, status) {
    state.isLoading = status;
  },

  SET_SETTINGS(state, features) {
    state.features = features;
  },

  SET_SETTINGS_SAVING(state, status) {
    state.isLoading = status;
  },
  HAS_WARNED_ONCE(state, data) {
    state.warnedOnce = data;
  },
};

export default mutation;
